import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { queryClient } from "./queryClient";
import "./i18n";
import "./index.css";
import { initMobileViewportInsets } from "./utils/lockAppViewportHeight";
import * as Sentry from "@sentry/react";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

initMobileViewportInsets();

Sentry.init({
  dsn: "https://2d94ada9c3fa15d1b4903dfa94d9acdc@o4510923530895360.ingest.de.sentry.io/4510923533779024",
  sendDefaultPii: true,
  enableLogs: true,
  enabled: process.env.REACT_APP_NODE_ENV === "production",
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
